import React from "react";
import { Loja } from "../../../../types/loja";

interface LojaSelectorProps {
  lojas: Loja[];
  selectedLojaId?: number;
  showLojaSelector: boolean;
  onSelectAllLojas?: () => void;
  onSelectLoja?: (id: number) => void;
}

export const LojaSelector: React.FC<LojaSelectorProps> = ({
  lojas,
  selectedLojaId,
  showLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  if (!showLojaSelector || lojas.length === 0) {
    return null;
  }

  return (
    <div className="fixed left-4 top-16 z-40 min-w-48 rounded-lg bg-black/80 p-4 backdrop-blur-sm">
      <h3 className="mb-2 font-semibold text-white">Selecionar Loja:</h3>
      <div className="space-y-1">
        <button
          type="button"
          onClick={onSelectAllLojas}
          className={`w-full rounded px-3 py-2 text-left text-sm transition-colors ${
            !selectedLojaId
              ? "bg-red-600 text-white"
              : "bg-white/10 text-white hover:bg-white/20"
          }`}
        >
          Todas as Lojas
        </button>
        {lojas.map((loja) => (
          <button
            key={loja.id}
            type="button"
            onClick={() => onSelectLoja?.(loja.id)}
            className={`w-full rounded px-3 py-2 text-left text-sm transition-colors ${
              selectedLojaId === loja.id
                ? "bg-red-600 text-white"
                : "bg-white/10 text-white hover:bg-white/20"
            }`}
          >
            {loja.nome}
          </button>
        ))}
      </div>
    </div>
  );
};
